export default __webpack_public_path__ + "static/getting-started-en_v2-1c2a787a5fbce52c2de3b4a8058bd09b.pdf";